import { useMemo } from 'react';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import Utils from '@utils/utils';
import styles from './SampleExamples.module.scss';

const SAMPLE_MAP = {
    model: [
        { img: 'samlpe-model/1.png', label: '单人照片' },
        { img: 'samlpe-model/2.png', label: '参考图服饰与商品版型类似' },
        { img: 'samlpe-model/3.png', label: '姿势过于复杂', error: true },
        { img: 'samlpe-model/4.png', label: '人物占比过小', error: true },
    ],
    modelBg: [
        { img: 'samlpe-model/1.png', label: '单人照片' },
        { img: 'samlpe-model/3.png', label: '姿势过于复杂', error: true },
        { img: 'samlpe-model/4.png', label: '人物占比过小', error: true },
    ],
    commodity: [
        { img: 'samlpe-commodity/1.png', label: '商品清晰' },
        { img: 'samlpe-commodity/2.png', label: '商品无遮挡' },
        { img: 'samlpe-commodity/3.png', label: '单件商品图' },
    ],
    video: [
        { img: 'samlpe-video/1.png', label: '单人' },
        { img: 'samlpe-video/2.png', label: '清晰半身/全身视频' },
        { img: 'samlpe-video/3.png', label: '勿切镜运镜', error: true },
    ],
};

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/';

const SampleExamples = ({ type = 'model' }) => {
    const list = useMemo(() => SAMPLE_MAP[type] || SAMPLE_MAP.model, [type]);

    return (
        <div className={styles.wrap}>
            {list.map((item) => (
                <div key={`${type}_${item.img}`} className={styles.item}>
                    <img src={Utils.getImgThumbnail(`${BASE_URL}${item.img}`)} alt="" />
                    <p className={item.error ? styles.errorText : styles.okText}>
                        {item.error ? (
                            <CloseCircleFilled className={styles.errorIcon} />
                        ) : (
                            <CheckCircleFilled className={styles.okIcon} />
                        )}
                        {item.label}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default SampleExamples;
